import { useState, useEffect } from "react";
import { motion, AnimatePresence, useScroll, useSpring } from "framer-motion";
import { HiOutlineArrowNarrowUp } from "react-icons/hi";

const ScrollToTopBTN = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  // 1. Obtenemos el progreso crudo
  const { scrollYProgress } = useScroll();
  
  // 2. Aplicamos el suavizado (Spring) al progreso para que el círculo se mueva elegante
  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  useEffect(() => {
    const toggleVisibility = () => {
      // Aparece tras bajar 400px
      if (window.pageYOffset > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, x: -20, scale: 0.8 }}
          animate={{ opacity: 1, x: 0, scale: 1 }}
          exit={{ opacity: 0, x: -20, scale: 0.8 }}
          className="fixed bottom-8 left-8 z-[100]"
        >
          <button
            onClick={scrollToTop}
            className="relative w-12 h-12 flex items-center justify-center group outline-none"
          >
            {/* SVG del Círculo de Progreso */}
            <svg className="absolute w-full h-full -rotate-90" viewBox="0 0 50 50">
              {/* Fondo del círculo (pista) */}
              <circle
                cx="25"
                cy="25"
                r="22"
                fill="none"
                className="stroke-white/10"
                strokeWidth="2"
              />
              {/* Progreso animado con smoothProgress */}
              <motion.circle
                cx="25"
                cy="25"
                r="22"
                fill="none"
                className="stroke-[#F26B1D]"
                strokeWidth="2"
                strokeLinecap="round"
                style={{ pathLength: smoothProgress }} 
              />
            </svg>

            {/* Icono Central Estilo 'Planix' */}
            <div className="bg-[#1C1C1C] w-9 h-9 rounded-full flex items-center justify-center text-white group-hover:bg-[#F26B1D] transition-all duration-300 shadow-xl group-active:scale-90">
              <HiOutlineArrowNarrowUp size={18} className="group-hover:-translate-y-1 transition-transform duration-300" />
            </div>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTopBTN;